export * from "./client/client";

export { ErrorBoundary } from "@datadog/browser-rum-react";
